import type { ReactNode } from 'react'
import { cn } from '@/lib/utils'

export function SectionLabel({
  index,
  as: Tag = 'p',
  id,
  className,
  children,
}: {
  index?: number
  as?: 'p' | 'h2' | 'div'
  id?: string
  className?: string
  children: ReactNode
}) {
  return (
    <Tag
      id={id}
      className={cn(
        'flex items-center gap-4 font-code text-[11px] font-medium uppercase tracking-[0.24em] text-[var(--surface-muted)]',
        className,
      )}
    >
      <span className="inline-flex shrink-0 items-center gap-2.5">
        <span
          aria-hidden="true"
          className="size-1.5 rounded-full bg-[var(--color-brand-accent)] shadow-[0_0_10px_rgba(0,229,255,0.9)]"
        />
        <span>
          {index !== undefined && (
            <span className="text-[var(--color-brand-accent-readable)]">
              {String(index).padStart(2, '0')} /{' '}
            </span>
          )}
          {children}
        </span>
      </span>
      <span
        aria-hidden="true"
        className="h-px min-w-8 flex-1 bg-gradient-to-r from-[var(--surface-border-strong)] via-[var(--surface-border)] to-transparent"
      />
    </Tag>
  )
}

export function Muted({ className, children }: { className?: string; children: ReactNode }) {
  return <span className={cn('text-gradient-muted', className)}>{children}</span>
}

export function Accent({ className, children }: { className?: string; children: ReactNode }) {
  return <span className={cn('text-gradient-accent', className)}>{children}</span>
}

export function Gold({ className, children }: { className?: string; children: ReactNode }) {
  return <span className={cn('text-gradient-gold', className)}>{children}</span>
}
